// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7735761","239":"4e39d26c","455":"668014b3"}[chunkId] + ".chunk.js";
};